export const headerHeight = 170;
export const headerHeightMobile = 120;
export const headerHeightMobileXs = 70;

export const leftMenuWidth = 300;
export const leftMenuWidthMobile = 250;

export const basepath = process.env.PUBLIC_URL;

// ASF-regex: Can't start with "0" or "+". At least 8 char long
export const regExCobraMobile =
	"^([1-9]{1}\\d{7,})$";
export const regExCobraEmail =
	"^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$";
